const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMysql(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(10.588235%,60.784316%,85.882354%)",
      fillOpacity: 1
    },
    d: "M 2.285156 11.882812 L 2.285156 15.367188 C 2.3125 17.199219 5.328125 18.679688 10 18.679688 C 14.671875 18.679688 17.683594 17.199219 17.714844 15.367188 L 17.714844 11.882812 Z M 2.285156 11.882812 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 17.714844 11.867188 C 17.714844 13.8125 14.691406 15.382812 10 15.382812 C 5.308594 15.382812 2.285156 13.8125 2.285156 11.867188 C 2.285156 9.929688 5.308594 8.351562 10 8.351562 C 14.691406 8.351562 17.714844 9.925781 17.714844 11.867188 Z M 17.714844 11.867188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(10.588235%,60.784316%,85.882354%)",
      fillOpacity: 1
    },
    d: "M 2.285156 8.367188 L 2.285156 11.460938 C 2.3125 13.292969 5.328125 14.96875 10 14.96875 C 14.671875 14.96875 17.683594 13.292969 17.714844 11.460938 L 17.714844 8.367188 Z M 2.285156 8.367188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 17.714844 8.351562 C 17.714844 10.296875 14.691406 11.867188 10 11.867188 C 5.308594 11.867188 2.285156 10.296875 2.285156 8.351562 C 2.285156 6.414062 5.308594 4.839844 10 4.839844 C 14.691406 4.839844 17.714844 6.410156 17.714844 8.351562 Z M 17.714844 8.351562 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(10.588235%,60.784316%,85.882354%)",
      fillOpacity: 1
    },
    d: "M 2.285156 4.851562 L 2.285156 7.945312 C 2.3125 9.777344 5.328125 11.453125 10 11.453125 C 14.671875 11.453125 17.683594 9.777344 17.714844 7.945312 L 17.714844 4.851562 Z M 2.285156 4.851562 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(24.313726%,83.92157%,100%)",
      fillOpacity: 1
    },
    d: "M 17.714844 4.835938 C 17.714844 6.78125 14.691406 8.351562 10 8.351562 C 5.308594 8.351562 2.285156 6.78125 2.285156 4.835938 C 2.285156 2.894531 5.308594 1.320312 10 1.320312 C 14.691406 1.320312 17.714844 2.894531 17.714844 4.835938 Z M 17.714844 4.835938 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMysql);
export default __webpack_public_path__ + "static/media/MYSQL.fc9227129ca9e64452ad1b067cde85f1.svg";
export { ForwardRef as ReactComponent };